import { JOURNEYS } from "../data/journeys.js";
import HangQuet from "./HangQuet.jsx";

/**
 * Bốn thẻ "Hôm nay, bạn muốn giải quyết việc gì?". Máy tính: lưới; điện thoại:
 * hàng quẹt ngang (HangQuet). Thẻ "Nên bắt đầu ở đây" đứng đầu hàng trên điện
 * thoại (CSS `order`), vì thẻ cuối hàng quẹt ít người thấy.
 *
 * renderThe: hàm vẽ một thẻ (TheHanhTrinh trong Home.jsx), truyền vào để
 * tránh import vòng giữa component và trang.
 */
export default function TheViecLuoi({ renderThe }) {
  return <HangQuet className="the-viec-luoi">{JOURNEYS.map((j) => renderThe(j))}</HangQuet>;
}
